import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  backgroun-color: #F2F2F2;
`

export const PaymentMethodsContainer = styled.div`
  background-color: #FFF;
  max-width: 360px;
  width: 100%;
  padding-top: 15px;

  .title {
    color: #005FAE;
    font-size: 18px;
    font-weight: 400;
    margin-left: 16px;
  }
  
  .payment-methods {
    margin-top: 15px;
    display: flex;
    flex-direction: column;

    .payment-option {
      display: flex;
      align-items: center;
      width: 100%;
      gap: 8px;
      justify-content: start;
      padding: 16px 23px;
      border-bottom: 1px solid #E5E4E5;
      font-size: 14px;
      font-weight: 1000;
      cursor: pointer;
      
      &:hover {
        background-color: #e4e9ed;
      }
      
      > svg {
        color: #F58220;
        font-size: 20px;
      }
    }

    .pix-container {
      border-top: 1px solid #E5E4E5;
    }

    .credit-container, .pix-container {
      .credit-options {
        
        .credit-option {
          padding: 13px 23px;
          width: 100%;
          display: flex;
          align-items: top;
          justify-content: start;
          gap: 8px;
          border-bottom: 1px solid #E5E4E5;
          cursor: pointer;

          svg {
            margin-top: 3px;
          }

          svg.checkbox-item {
            cursor: pointer;
            font-size: 16px;
            color: #F58220;        
          }

          .option-infos {
            display: flex;
            gap: 10px;
          }

          .values {
            display: flex;
            flex-direction: column;
            font-size: 14px;
            font-weight: 700;

            span, p {
              color: #005FAE;
            }
            strong {
              color: #F58220;
            }

            p {
              span {
                font-size: 10px;
              }
            }

          }

          .best-option {
            display: flex;
            flex-direction: column;
            align-items: center;

            .best-title {
              padding: 6.5px 10px;
              border-radius: 5.5px;
              background: #f58220;
              text-align: center;
              font-size: 12px;
              color: #fff;
            }

            .best-cet {
              font-size: 10px;
              color: #005FAE;
              margin-top: 3px;
              font-weight: 600;
            }
            
          }

          &.selected {
            background-color: #005FAE;
            .values, .best-option {
              span, p {
                color: #fff;
              }
            }
            &:hover {
              background-color: #2070b3;
            }
          }

          &:hover {
            background-color: #f1f1f1;
          }
        }
      }
    }
  }
`

export const VehicleDetailsContainer = styled.div`
  width: 100%;
  padding: 48px;
  
  
  .details-container {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;

    > div {
      margin-bottom: 25px;
    }
  
    div.contact-and-ticket {
      display: flex;
      gap: 15px;
      width: 100%;
      max-width: 1200px;
      
      > div {
        width: 100%;
      }
    }
  }
`

export const ConsultResultContainer = styled.div`
  background-color: #FFF;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.3);

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    .title-txt {
      color: #005FAE;
      font-size: 18px;
    }

    .info {
      color: #807E80;
      font-size: 14px;
    }
  }

  .title {
    font-size: 18px;
    font-weight: 600;
  }

  .car-details {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    gap: 15px;

    > div {
      background-color: #F7F7F7;
      border-radius: 12px;
      padding: 20px;
      width: 100%;
      min-height: 122px;
    }

    .infos {
      font-size: 16px;
      
      > span {
        display: block;
        margin-top: 8px;
      }

      .header {
        width: 100%;

        .placa,
        .place {
          color: #F58220;
          display: flex;
          align-items: center;
          gap: 6px;
          font-weight: 600;
        }  

        .placa {
          svg {
            font-size: 22px;
          }
        }
      }
    }

    .warn-message {
      color: #807E80;
      font-size: 16px;
      width: 100%;
    }
  }

  .tickets {  
    margin-top: 20px;
  }
`

export const ContactContainer = styled.div`
  background-color: #FFF;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.3);
  height: fit-content;

  h3 {
    font-size: 18px;
  }

  .content {
    display: flex;
    width: 100%;
    margin-top: 5px;

    > div {
      width: 100%;

      .item {
        margin-top: 12px;
        strong, span {
          display: block;
          font-size: 14px;
        }
      }

      .icons {
        display: flex;
        gap: 10px;

        svg {
          cursor: pointer;
          color: #F58220;
          font-size: 29px;
        }
      }
    }    
  }
`
export const CouponContainer = styled.div<{ valid: boolean | undefined, open: boolean }>`
  .coupon-container {
    background-color: #FFF;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.3);
    height: fit-content;
  
    .header-togg{
      display: flex;
      gap: 10px;
      justify-content: space-between;
  
      .main-togg {
        cursor: pointer;
        font-size: 16px;
        gap: 8px;
        display: flex;
        align-items: center;
        margin-bottom: ${props => props.open ? "15px" : "0"};
    
        &:hover {
          opacity: 0.8;
        }
    
        span {
          text-decoration: underline;
        }
        
        > svg {
          color: #F58220;
        }
      }
    }
  
    .available-status {
      color: #FFF;
      background-color: #F58220;
      margin-bottom: 15px;
      width: fit-content;
      padding: 10px 12px;
      border-radius: 12px;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;
  
      &:hover {
        opacity: 0.85;
      }
    }
  
    .content {
  
      .descount-values {
        div {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #4D4C4D;
          font-size: 16px;
          margin-top: 12px;
        }
      }
  
      .ticket-input {
        width: 100%;
        
        input {
          font-size: 14px;
        }
  
        label {
          display: none;
        }
        
        svg {
          font-size: 14px;
          color: ${props => props.valid ? "#F58220" : "#FC0027"};
        }
  
      }
    }
  }

  div.actions {
    margin-top: 25px;
    width: 100%;
    display: flex;
    justify-content: end;
    gap: 30px;

    .new-consult {
      color: #F58220;
      font-size: 16px;
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;

      span {
        text-decoration: underline;
        font-weight: 500;
      }

      &:hover {
        opacity: 0.8;
      }
    }

    .submit-btn {
      color: #FFF;
      background-color: #F58220;
      font-size: 16px;
      display: flex;
      align-items: center;
      padding: 13px;
      border-radius: 12px;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }

      svg {
        margin-left: 8px;
      }
    }
  }
`

export const DebtsContainer = styled.div`
  .last {
    border: none !important;
  }

  .debts:not(:last-child) {
    border-bottom: 1px solid #F58220;
  }

  .debts {
    margin: 10px 0;
    padding: 5px;      

    .tickets-togg {  
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      color: #4D4C4D;
      font-weight: 400;
      
      .quantity {
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
  
        &:hover {
          opacity: 0.85;
        }
  
        svg:not(.checkbox-item) {
          color: #F58220;
          font-size: 14px;
        }
      }
    }
    
    .tickets-container {
      .ticket:not(:last-child) {
        border-bottom: 1px solid #E5E4E5;
      }

      .ticket {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 7px 0 7px 20px;
        cursor: pointer;
  
        &:hover {
          svg {
            opacity: 0.8;
          }
        }
  
        .ticket-description {
          width: 100%;
          min-width: 150px;
          color: #807E80;
          font-size: 14px;
          font-weight: 300;
          padding: 0 12px;
        }
  
        .ticket-value {
          display: flex;
          gap: 12px;
          justify-content: end;
          align-items: center;
          min-width: 160px;
          
          .expired {
            font-size: 14px;
            font-weight: 600;
            color: #FC0027;
            padding: 2px 4px;
            border-radius: 6px;
            background-color: #FDC3C3;
          }
          .normal {
            font-size: 14px;
            font-weight: 600;
            color: #F58220;
            padding: 2px 4px;
            border-radius: 6px;
            background-color: #f5e6d9;
          }
        }
      }
      .last {
        border: none;
      }
    }
  }



  svg.checkbox-item {
    cursor: pointer;
    font-size: 18px;
    color: #F58220;
    min-width:18px;
  }  

`